import {
    provideHttpClient,
    withInterceptors,
    withNoXsrfProtection,
    withRequestsMadeViaParent,
} from '@angular/common/http';
import { EnvironmentProviders, Provider } from '@angular/core';
import { IsAuthenticatedGuard } from '@core/guards/is-authenticated.guard';
import { IsVerifiedGuard } from '@core/guards/is-verified.guard';
import { CacheService } from '@core/services/cache.service';
import { DjangoService } from '@core/services/django.service';
import { IncompleteTripCheckService } from '@features/client-dashboard/services/incomplete-trip-check.service';
import { impersonationInterceptor } from '@features/impersonation/interceptors/impersonation.interceptor';
import { ImpersonationService } from '@features/impersonation/services/impersonation.service';
import { ModalService } from '@features/modal/services/modal.service';
import { UserService } from '@features/user/services/user.service';

/**
 * Fresh instances of every root service the dashboard reaches the API through,
 * wired to an HttpClient that sends the impersonation header. A service left
 * out keeps the root HttpClient and quietly shows the staff member's own data.
 */
export function provideImpersonation(): (Provider | EnvironmentProviders)[] {
    return [
        provideHttpClient(
            withNoXsrfProtection(),
            withInterceptors([impersonationInterceptor]),
            withRequestsMadeViaParent()
        ),
        ImpersonationService,
        CacheService,
        DjangoService,
        UserService,
        IncompleteTripCheckService,
        ModalService,
        IsAuthenticatedGuard,
        IsVerifiedGuard,
    ];
}
